/* Khalwa.co — theme scripts (no dependencies) */
(() => {
  const K = (window.Khalwa = window.Khalwa || {});
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const routes = Object.assign({ cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' }, window.routes || {});
  // Static preview (opened as a local file) has no Shopify backend: keep a pretend cart in memory.
  const PREVIEW = location.protocol === 'file:' || !!window.KHALWA_PREVIEW;

  /* ---------- Money ---------- */
  K.formatMoney = (cents) => {
    const fmt = K.moneyFormat || '{{amount_with_comma_separator}} kr';
    const n = (cents / 100);
    const withComma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma.replace(/,00$/, ''))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2));
  };

  /* ---------- Header ---------- */
  const header = $('.header-wrapper');
  const announcement = $('.announcement');
  const setAnn = () => document.documentElement.style.setProperty('--announcement-h', (announcement ? announcement.offsetHeight : 0) + 'px');
  setAnn(); addEventListener('resize', setAnn);
  const onScroll = () => header && header.classList.toggle('is-scrolled', scrollY > 40);
  onScroll(); addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Mobile menu ---------- */
  const menu = $('#MobileMenu');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { menu.classList.add('is-open'); document.body.classList.add('no-scroll'); b.setAttribute('aria-expanded', 'true'); }));
  $$('[data-menu-close], #MobileMenu nav a').forEach((b) => b.addEventListener('click', () => { menu.classList.remove('is-open'); document.body.classList.remove('no-scroll'); $$('[data-menu-open]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  $$('.reveal, .reveal-img').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const main = $('.gallery__main', g);
    const thumbs = $$('.gallery__thumb', g);
    const dots = $$('.gallery__dots span', g);
    const go = (i) => main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' });
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    let raf;
    main.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      });
    }, { passive: true });
  });

  /* ---------- Variant pills -> hidden id + price ---------- */
  $$('[data-product-form]').forEach((form) => {
    const json = $('script[data-variants]', form.closest('[data-product]') || document);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('input[name="id"]', form);
    const update = () => {
      const chosen = $$('[data-option-index]', form.closest('[data-product]')).filter((i) => i.checked).map((i) => i.value);
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) return;
      idInput.value = v.id;
      $$('[data-price]').forEach((p) => (p.textContent = K.formatMoney(v.price)));
      $$('[data-add-button]').forEach((btn) => {
        btn.disabled = !v.available;
        const label = $('[data-add-label]', btn);
        if (label) label.textContent = v.available ? (K.strings?.add || 'Læg i kurv') : (K.strings?.soldOut || 'Udsolgt');
      });
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('[data-option-index]', form.closest('[data-product]')).forEach((i) => i.addEventListener('change', update));
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  const sticky = $('.sticky-atc');
  const mainAtc = $('[data-product-form] [data-add-button]');
  if (sticky && mainAtc && io) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(mainAtc);
  }

  /* ---------- Lookbook drag-to-scroll (desktop) ---------- */
  $$('[data-drag-scroll]').forEach((el) => {
    let down = false, startX = 0, start = 0, moved = false;
    el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; start = el.scrollLeft; el.classList.add('is-dragging'); });
    addEventListener('pointerup', () => { down = false; el.classList.remove('is-dragging'); });
    el.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = start - dx; });
    el.addEventListener('click', (e) => { if (moved) e.preventDefault(); }, true);
  });

  /* ======================================================================
     Cart drawer
     ====================================================================== */
  const drawer = $('#CartDrawer');
  const overlay = $('#CartOverlay');
  let previewCart = { items: [], item_count: 0, total_price: 0, total_discount: 0 };
  // Preview only: mimic Shopify's automatic "buy 2, get 1 free" discount (cheapest items free).
  const recalcPreview = () => {
    const c = previewCart;
    c.item_count = c.items.reduce((a, b) => a + b.quantity, 0);
    const units = c.items.flatMap((i) => Array(i.quantity).fill(i.price)).sort((a, b) => a - b);
    c.total_discount = units.slice(0, Math.floor(c.item_count / 3)).reduce((a, b) => a + b, 0);
    c.total_price = c.items.reduce((a, b) => a + b.final_line_price, 0) - c.total_discount;
  };

  const openDrawer = () => { if (!drawer) return; drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.classList.add('no-scroll'); drawer.setAttribute('aria-hidden', 'false'); setTimeout(() => $('.drawer__head button', drawer)?.focus(), 300); };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.classList.remove('no-scroll'); drawer.setAttribute('aria-hidden', 'true'); };
  K.openCart = openDrawer;
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { if (!drawer) return; e.preventDefault(); refreshCart().then(openDrawer); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); menu?.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } });

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let lastCount = null;
  const renderCart = (cart) => {
    $$('.cart-count').forEach((c) => {
      c.textContent = cart.item_count || ''; c.dataset.count = cart.item_count;
      if (lastCount !== null && cart.item_count !== lastCount) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
    });
    lastCount = cart.item_count;
    if (!drawer) return;
    $('[data-cart-count-label]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    const list = $('.drawer__items', drawer);
    const foot = $('.drawer__foot', drawer);
    const ship = $('.drawer__ship', drawer);
    if (!cart.items.length) {
      list.innerHTML = $('#CartEmptyTemplate').innerHTML;
      foot.hidden = true; if (ship) ship.hidden = true;
      const offerRow = $('.drawer__offer', drawer); if (offerRow) offerRow.hidden = true;
      return;
    }
    foot.hidden = false;
    list.innerHTML = cart.items.map((it, idx) => `
      <div class="line-item">
        <a href="${esc(it.url)}"><img src="${esc(it.image || '')}" alt="${esc(it.product_title)}" width="84" height="105" loading="lazy"></a>
        <div>
          <a class="line-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="line-item__meta">${esc(it.variant_title)}</div>` : ''}
          <div class="qty">
            <button type="button" aria-label="Færre" data-line-change="${idx + 1}" data-q="${it.quantity - 1}">−</button>
            <input type="number" value="${it.quantity}" min="0" aria-label="Antal" readonly>
            <button type="button" aria-label="Flere" data-line-change="${idx + 1}" data-q="${it.quantity + 1}">+</button>
          </div>
        </div>
        <div class="line-item__price">${K.formatMoney(it.final_line_price)}
          <button type="button" class="line-item__remove" data-line-change="${idx + 1}" data-q="0">Fjern</button>
        </div>
      </div>`).join('');
    $('[data-cart-total]', drawer).textContent = K.formatMoney(cart.total_price);
    const saving = $('.drawer__saving', drawer);
    if (saving) {
      saving.hidden = !(cart.total_discount > 0);
      $('[data-cart-saving]', saving).textContent = '−' + K.formatMoney(cart.total_discount || 0);
    }
    const offer = $('.drawer__offer', drawer);
    if (offer) {
      const n = cart.item_count, r = n % 3, free = Math.floor(n / 3);
      offer.hidden = false;
      $('[data-offer-text]', offer).innerHTML =
        r === 2 ? '<b>Læg 1 mere i kurven</b> – den er gratis!'
        : r === 1 ? (free ? `<b>${free} gratis</b> i kurven ✦ Læg 2 mere for endnu én` : '<b>Køb 2, få 1 gratis</b> – læg 2 mere i kurven')
        : `<b>Tillykke!</b> Du får ${free} gratis ✦`;
      const lit = r === 0 ? 3 : r;
      $$('.offer-steps span', offer).forEach((s, i) => s.classList.toggle('is-on', i < lit));
    }
    if (ship) {
      const goal = K.freeShippingCents || 0;
      ship.hidden = !goal;
      if (goal) {
        const left = goal - cart.total_price;
        $('[data-ship-text]', ship).innerHTML = left > 0 ? `Du mangler <b>${K.formatMoney(left)}</b> for gratis fragt` : '<b>Tillykke!</b> Du har fået gratis fragt ✦';
        $('.ship-bar span', ship).style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
      }
    }
  };

  const refreshCart = async () => {
    if (PREVIEW) { renderCart(previewCart); return previewCart; }
    const cart = await fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    renderCart(cart); return cart;
  };

  const changeLine = async (line, quantity) => {
    if (PREVIEW) {
      const it = previewCart.items[line - 1];
      if (quantity <= 0) previewCart.items.splice(line - 1, 1); else { it.quantity = quantity; it.final_line_price = it.price * quantity; }
      recalcPreview(); renderCart(previewCart); return;
    }
    const cart = await fetch(routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) }).then((r) => r.json());
    renderCart(cart);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (b) changeLine(parseInt(b.dataset.lineChange, 10), parseInt(b.dataset.q, 10));
  });

  const addToCart = async (form) => {
    const btn = $('[data-add-button]', form) || form.querySelector('button[type="submit"]');
    btn?.classList.add('is-loading');
    try {
      if (PREVIEW) {
        const d = form.dataset; const q = parseInt(form.quantity?.value || '1', 10);
        const existing = previewCart.items.find((i) => i.url === d.url);
        if (existing) { existing.quantity += q; existing.final_line_price = existing.price * existing.quantity; }
        else previewCart.items.push({ product_title: d.title, url: d.url, image: d.image, price: +d.price, quantity: q, final_line_price: +d.price * q, variant_title: '' });
        recalcPreview(); renderCart(previewCart);
      } else {
        const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) { const err = await res.json(); alert(err.description || 'Der skete en fejl. Prøv igen.'); return; }
        await refreshCart();
      }
      openDrawer();
    } finally { btn?.classList.remove('is-loading'); }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer) return;
    e.preventDefault(); addToCart(form);
  });
  // "Buy 2, get 1 free" bundle: add every product in the bundle at once.
  $$('[data-bundle-add]').forEach((btn) => btn.addEventListener('click', async () => {
    const items = $$('[data-bundle-item]', btn.closest('[data-bundle]'));
    btn.classList.add('is-loading');
    try {
      if (PREVIEW) {
        items.forEach(({ dataset: d }) => {
          const existing = previewCart.items.find((i) => i.url === d.url);
          if (existing) { existing.quantity += 1; existing.final_line_price = existing.price * existing.quantity; }
          else previewCart.items.push({ product_title: d.title, url: d.url, image: d.image, price: +d.price, quantity: 1, final_line_price: +d.price, variant_title: '' });
        });
        recalcPreview(); renderCart(previewCart);
      } else {
        const res = await fetch(routes.cart_add_url + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map((i) => ({ id: +i.dataset.id, quantity: 1 })) })
        });
        if (!res.ok) { const err = await res.json(); alert(err.description || 'Der skete en fejl. Prøv igen.'); return; }
        await refreshCart();
      }
      openDrawer();
    } finally { btn.classList.remove('is-loading'); }
  }));

  $$('[data-sticky-add]').forEach((b) => b.addEventListener('click', () => { const f = $('[data-product-form]'); if (f) addToCart(f); }));

  if (!PREVIEW) refreshCart().catch(() => {});
  else renderCart(previewCart);
})();
